import { BaseError } from '@kiplin/web-common/error';

export class MissingJwtTokenError extends BaseError {
  constructor() {
    super(
      'c0e0cb8f-dad2-4bb3-bc8c-284c4a4085e3',
      'Unable to resolve cockpit API token. Ensure the Vue app rendered an apiToken prop.',
    );
  }
}
